const ACCEPT_AGE_CHECK = 'app/ageCheck/ACCEPT_AGE_CHECK';

export {
  ACCEPT_AGE_CHECK
};